import { render, staticRenderFns } from "./tf.vue?vue&type=template&id=c469ed76&scoped=true"
import script from "./tf.vue?vue&type=script&lang=js"
export * from "./tf.vue?vue&type=script&lang=js"
import style0 from "./tf.vue?vue&type=style&index=0&id=c469ed76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c469ed76",
  null
  
)

export default component.exports